import createApp from 'framework/createApp';
import {setConfig} from 'framework/siteConfig';
import AppComponent from './App';
setConfig('AppComponent', AppComponent);
const app = createApp();
export default app._store;
